import { attributesToProps, domToReact } from 'html-react-parser';
import { Link } from '@/app_components/common/Link';
import type { DOMNode, ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';

export const LinkParser = ({ domNode }: ParserProps) => {
  const { attribs, children } = domNode;
  const props = attributesToProps(attribs);
  const { href, className } = props;
  return (
    <Link
      className={cn(className)}
      href={href?.toString() || ''}
      prefetch={false}
      {...props}
    >
      {domToReact(children as DOMNode[])}
    </Link>
  );
};
